import {
    SHOW_GENERAL_ERROR,
    HIDE_GENERAL_ERROR,
    REQUEST_CLOSE_DROPDOWN_ON_SCHEDULE,
    CLOSE_DROP_DOWN_ON_SCHEDULE_SUCCESS,
    REDIRECT_URL,
    REDIRECT_URL_SUCCEEDED,
    HANDLE_SCHEDULE_TICKET_CLICK,
    HANDLE_SCHEDULE_TICKET_CLICK_SUCCEEDED,
    REMOVE_SCHEDULE_TICKET_CLICK,
    REMOVE_SCHEDULE_TICKET_CLICK_SUCCEEDED
} from './types';

export const showGeneralError = (payload) => ({
    type: SHOW_GENERAL_ERROR,
    payload,
});

export const hideGeneralError = (payload) => ({
    type: HIDE_GENERAL_ERROR,
    payload,
});

export const closeDropDownOnSchedulePageRequest = (payload) => ({
    type: REQUEST_CLOSE_DROPDOWN_ON_SCHEDULE,
    payload,
});

export const closeDropDownOnSchedulePageSuccess = (payload) => ({
    type: CLOSE_DROP_DOWN_ON_SCHEDULE_SUCCESS,
    payload,
});

export const handleScheduleTicketClick = (payload) => ({
    type: HANDLE_SCHEDULE_TICKET_CLICK,
    payload
}) 

export const handleScheduleTicketClickSucceeded = (payload) => ({
    type: HANDLE_SCHEDULE_TICKET_CLICK_SUCCEEDED,
    payload
})

export const removeScheduleTicketClick = (payload) => ({
    type: REMOVE_SCHEDULE_TICKET_CLICK,
    payload
})

export const removeScheduleTicketClickSucceeded = (payload) => ({
    type: REMOVE_SCHEDULE_TICKET_CLICK_SUCCEEDED,
    payload
})



// WEBPACK FOOTER //
// ./src/SHARED/actions/general.actions.js